<template>
	<header class="container-navigation">
		<div class="container">
			<div class="row">
				<div class="col-lg-7 col-7 logo">
					<img v-if="mainSettings.logo" :src="`${mainSettings.logo}`" alt=""
						:style="{ 'max-height': mainSettings.logoMaxHeight, 'max-width': mainSettings.logoMaxWidth }">
				</div>
				<div class="col-lg-5 col-5 navi">
					<div class="hamburger">
						<div class="menuebutton" v-on:click="toggle" v-bind:class="{ active: isActive }">

							<span class="bar"></span>
							<span class="bar"></span>
							<span class="bar"></span>
						</div>
					</div>
					<div v-on:click="toggle" v-bind:class="{ active: isActive }" class="container-xl navbar-inner">
						<ul class="nav">
							<template v-for="(navlink, index) in navigationData" :key="index">
								<li v-if="navlink.config.pictures != '' && navlink.type != 'freeTexts' && navlink.config.title != ''">
									<a :href="['#' + index]" class="nav-link">{{ navlink.config.title }}</a>
								</li>
								<template v-else-if="navlink.type == 'freeTexts'">
									<template v-for="(field, index) in navigationData[index].config.fields" :key="index">
										<li v-if="field.type != ''" class="nav-item">
											<a class="nav-link" :href="['#container-' + index + '-' + field.type]">{{ field.title }}</a>
										</li>
									</template>
								</template>
							</template>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>


<script>
export default {
	props: {
		mainSettings: {
			type: Object
		},
		navigationData: {
			type: Object
		},
		titleData2: {
			type: Object
		}
	},

	data() {
		return {
			isActive: false,
			a: false,
		}
	},

	methods: {
		toggle() {
			this.isActive = !this.isActive;
			this.a = !this.a;
		}
	},
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/navigationComponent.scss";
@import "@/assets/scss/design-wien/titleComponent.scss";
</style>